import React, { FC } from 'react'

import { TRANSLATIONS as T } from '../../../constants'
import { CommonPageProps } from '../../../types/interface/fsm.interface'
import WhenWhereForm from '../../../components/Claims/WhenWhereForm'
import { Typography, useTranslate, FNOLPageWrapper } from '@dg-shared'

const PageLocationAndTime: FC<CommonPageProps> = ({ service }) => {
  const { t } = useTranslate(T.FNOL_OTHER_WHEN_WHERE)

  return (
    <FNOLPageWrapper breadcrumbsBtnText={t(`${T.COMMON}/back`)} breadcrumbsStepPercentage={70}>
      <Typography type='h1'>{t('title')}</Typography>
      <Typography>{t('subtitle')}</Typography>
      <WhenWhereForm send={service.send} />
    </FNOLPageWrapper>
  )
}

export default PageLocationAndTime
